import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { VCardPreviewType } from '@/lib/types/VCardT'

export type RightSidebarState = {
  vCardData: VCardPreviewType | null
}

const initialState: RightSidebarState = {
  vCardData: null,
}

const rightSidebarSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setVCardData(state, action: PayloadAction<VCardPreviewType | null>) {
      state.vCardData = action.payload
    },
  },
})

export const { setVCardData } = rightSidebarSlice.actions
export default rightSidebarSlice.reducer
